<!-- 饼状图表 -->
<template>
  <div class="echarts">
    <div ref="echartNode" style="height:100%;"></div>
  </div>
</template>

<script>
  import * as echarts from "echarts";
  export default {
    name: 'PieChart',
    components: {},
    props: {
      echartData: {
        type: Object,
        default () {
          return null
        }
      },
    },
    data() {
      return {
        chartOptions: {
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            right: 10,
            top: 'center',
            itemGap: 15,
            formatter: (name) => {
              return name;
            }
          },
          color: ['#60B7DC', '#EFDB1C', '#5470C6', '#91CC75', '#FAC858', '#EE6666', '#73C0DE', '#3BA272', '#FC8452', '#9A60B4', '#EA7CCC'],
          series: [{
            name: '客户兴趣',
            type: 'pie',
            radius: ['50%', '70%'],
            center: ['40%', '50%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 4,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: true,
              position: 'center',
              fontSize: 20,
              fontWeight: 'bold',
              formatter: function() {
                return '0\n总浏览';
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: []
          }]
        },
        echarts: null,
        totalCount: 0
      }
    },
    created() {},
    mounted() {
      this.calcEcharts()
    },
    methods: {
      calcEcharts() {
        if (!this.echartData) {
          return;
        }
        if (!this.echarts) {
          this.echarts = echarts.init(this.$refs.echartNode);
          // 添加窗口改变监听
          this.echarts._resize = () => {
            this.echarts.resize();
          };
          window.addEventListener("resize", this.echarts._resize);
        }
        
        // sourceType 映射关系
        const sourceTypeMap = {
          1: '分享物料',
          2: '项目管理',
          3: '顾客物料',
          4: '案例展示',
          5: '业务物料',
          6: '品宣',
          7: '皮科普药',
          8: '新闻资讯'
          // 9: '患者就诊物料'
        };

        // 构建饼图数据
        const pieData = [];
        
        // 添加商品
        if (this.echartData.shangpin > 0) {
          pieData.push({
            value: this.echartData.shangpin,
            name: '商品'
          });
        }
        
        // 添加课程
        if (this.echartData.kecheng > 0) {
          pieData.push({
            value: this.echartData.kecheng,
            name: '课程'
          });
        }
        
        // 添加 countList 中的分类
        if (this.echartData.countList && this.echartData.countList.length > 0) {
          this.echartData.countList.forEach(item => {
            if (item.valueLong1 > 0 && item.keyLong1) {
              const typeName = sourceTypeMap[item.keyLong1] || `类型${item.keyLong1}`;
              pieData.push({
                value: item.valueLong1,
                name: typeName
              });
            }
          });
        }
        
        // 计算总浏览数
        this.totalCount = pieData.reduce((sum, item) => sum + item.value, 0);
        
        // 更新图表配置
        this.chartOptions.series[0].data = pieData;
        
        // 更新中心显示的总浏览数
        this.chartOptions.series[0].label.formatter = () => {
          return this.totalCount + '\n总浏览';
        };
        
        // 更新图例格式化函数，显示名称和数值
        this.chartOptions.legend.formatter = (name) => {
          const item = pieData.find(d => d.name === name);
          return name + ' ' + (item ? item.value : 0);
        };
        
        this.refreshChart();
      },
      refreshChart() {
        if (!this.echarts) {
          return;
        }
        this.echarts.clear();
        this.echarts.setOption(this.chartOptions);
      }
    },
    watch: {
      echartData: {
        handler(newVal) {
          if (newVal) {
            this.calcEcharts()
          }
        },
        deep: true
      }
    }
  }
</script>
<style lang='scss' scoped>
  .echarts {
    width: 100%;
    height: 400px;
  }
</style>
